<div class="label_properties">
  <small class="debug">{{me}}</small>
  @if (dynamicsInitialized) {
    <div>
      <dynamic-form [fields]="uiConfigInit" (submit)="submit($event)">
      </dynamic-form>
      <!-- <app-font-selector (onChange)="onFontChanged($event, '', 'AdNet')" [setConfig]="{i_config: sceneItem}"></app-font-selector> -->
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
    </div>
  }
</div>
